import { useEffect, useState } from "react";
import axios from "axios";
import ReactPaginate from "react-paginate";
import Table from "../../components/Table/Table";
import classes from "./Bookings.module.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import InputField from "../../components/ui/InputField/InputField";
import { env } from "../../constants/env";

const Bookings = () => {
  const [bookings, setBookings] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [showTableDialog, setShowTableDialog] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();
  const itemsPerPage = 10;

  const columns = [
    // { key: "id", label: "ID" },
    { key: "customer", label: "CUSTOMER" },
    { key: "car", label: "CAR" },
    { key: "date", label: "DATE" },
    { key: "status", label: "STATUS" },
    { key: "amount", label: "AMOUNT" },
  ];

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const res = await axios.get(
          `${env.apiUrl}/api/bookings?page=${currentPage}&limit=${itemsPerPage}&search=${searchTerm}`
        );

        const { bookings, totalPages } = res.data;

        setBookings(bookings);
        setPageCount(totalPages);
      } catch (err) {
        console.error("Failed to fetch bookings:", err);
      }
    };

    fetchBookings();
  }, [currentPage, searchTerm]);

  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1;
    setCurrentPage(selectedPage);
  };

  return (
    <div className={classes.wrapper}>
      <InputField
        className="mb-3"
        search
        placeholder="Search bookings by customer"
        inputContainerClass={classes.inputContainer}
        value={searchTerm}
        onChange={(e) => {
          setSearchTerm(e.target.value);
          setCurrentPage(1);
        }}
      />
      <Table
        dataType={"Bookings"}
        data={bookings}
        columns={columns}
        showDialog={showTableDialog}
        setShowDialog={(value) => setShowTableDialog(value)}
        bookingInfo={() =>
          navigate(`bookings-management/${bookings[selectedBooking]?.id}`)
        }
        clickedIndex={(value) => setSelectedBooking(value)}
      />

      <div className="mt-4">
        <ReactPaginate
          previousLabel={
            <FaChevronLeft
              color={
                currentPage === 1
                  ? "var(--border-default)"
                  : "var(--text-secondary-color)"
              }
            />
          }
          nextLabel={
            <FaChevronRight
              color={
                currentPage === pageCount
                  ? "var(--border-default)"
                  : "var(--text-secondary-color)"
              }
            />
          }
          breakLabel={"..."}
          pageCount={pageCount}
          forcePage={currentPage - 1}
          marginPagesDisplayed={2}
          pageRangeDisplayed={1}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      </div>
    </div>
  );
};

export default Bookings;